import { gql } from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';

import {
  FilterBrands,
  FilterBrandsVariables,
  GetBrandIsFollowed,
  GetBrandIsFollowedVariables,
} from '@generated/graphql';
import { BrandFragments } from '@graphql/fragments/rutilus/BrandType';
import { PageFragments } from '@graphql/fragments/rutilus/PageType';

export const filterBrands: TypedDocumentNode<FilterBrands, FilterBrandsVariables> = gql`
  query FilterBrands($first: Int, $searchTerm: String) {
    brands(first: $first, filters: { nameContains: $searchTerm }) {
      edges {
        node {
          ...FilterBrandNodeFields
        }
      }
    }
  }
  ${BrandFragments.filterBrandNodeFields}
`;

export const getDiscoveredBrands = gql`
  query GetDiscoveredBrands($filters: PageFilters) {
    entry: pages(filters: $filters, first: 10) {
      edges {
        node {
          ...DiscoveredBrandNodeFields
        }
      }
    }
  }
  ${PageFragments.discoveredBrandNodeFields}
`;

export const getBrandIsFollowed: TypedDocumentNode<
  GetBrandIsFollowed,
  GetBrandIsFollowedVariables
> = gql`
  query GetBrandIsFollowed($externalId: String!) {
    entry: page(externalId: $externalId) {
      followedByCurrentUser
    }
  }
`;
